<template>
  <div class="information">
    <div class="information_header">
      <h1>Знания</h1>

      <div class="information_header-buttons">
        <button title="Фильтр поиска" class="filter-btn" @click="open(true)">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.58009 0.100098C1.98878 0.100098 2.32009 0.431407 2.32009 0.840098V1.5801C2.32009 1.98878 1.98878 2.3201 1.58009 2.3201C1.17141 2.3201 0.840093 1.98878 0.840093 1.5801V0.840098C0.840093 0.431407 1.17141 0.100098 1.58009 0.100098ZM1.5801 3.8001C2.39748 3.8001 3.0601 4.46272 3.0601 5.2801C3.0601 6.09748 2.39748 6.7601 1.5801 6.7601C0.762716 6.7601 0.100098 6.09748 0.100098 5.2801C0.100098 4.46272 0.762716 3.8001 1.5801 3.8001ZM14.1601 6.02026C14.9775 6.02026 15.6401 6.68288 15.6401 7.50026C15.6401 8.31766 14.9775 8.98026 14.1601 8.98026C13.3427 8.98026 12.6801 8.31766 12.6801 7.50026C12.6801 6.68288 13.3427 6.02026 14.1601 6.02026ZM7.50011 8.24002C8.31751 8.24002 8.98011 8.90261 8.98011 9.72002C8.98011 10.5374 8.31751 11.2 7.50011 11.2C6.68273 11.2 6.02011 10.5374 6.02011 9.72002C6.02011 8.90261 6.68273 8.24002 7.50011 8.24002ZM7.5001 12.6799C7.9088 12.6799 8.2401 13.0112 8.2401 13.4199V14.8999C8.2401 15.3086 7.9088 15.6399 7.5001 15.6399C7.09141 15.6399 6.7601 15.3086 6.7601 14.8999V13.4199C6.7601 13.0112 7.09141 12.6799 7.5001 12.6799ZM1.58009 8.24002C1.98878 8.24002 2.32009 8.57131 2.32009 8.98002V14.9C2.32009 15.3087 1.98878 15.64 1.58009 15.64C1.17141 15.64 0.840093 15.3087 0.840093 14.9V8.98002C0.840093 8.57131 1.17141 8.24002 1.58009 8.24002ZM14.1601 0.100098C14.5688 0.100098 14.9001 0.431407 14.9001 0.840098V3.8001C14.9001 4.20879 14.5688 4.5401 14.1601 4.5401C13.7514 4.5401 13.4201 4.20879 13.4201 3.8001V0.840098C13.4201 0.431407 13.7514 0.100098 14.1601 0.100098ZM14.1601 9.72026C14.5688 9.72026 14.9001 10.0516 14.9001 10.4603V14.9003C14.9001 15.309 14.5688 15.6403 14.1601 15.6403C13.7514 15.6403 13.4201 15.309 13.4201 14.9003V10.4603C13.4201 10.0516 13.7514 9.72026 14.1601 9.72026ZM7.5001 0.100098C7.9088 0.100098 8.2401 0.431407 8.2401 0.840098V6.0201C8.2401 6.42879 7.9088 6.7601 7.5001 6.7601C7.09141 6.7601 6.7601 6.42879 6.7601 6.0201V0.840098C6.7601 0.431407 7.09141 0.100098 7.5001 0.100098Z" fill="#CACDD3"/>
          </svg>
        </button>
        <button class="btn" @click="open(false)">
          <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="5" r="4" stroke="white" stroke-opacity="0.97" stroke-width="2" stroke-linecap="round"/>
            <path d="M12.7956 17.4471C12.4537 16.1713 11.7004 15.0439 10.6526 14.2399C9.6047 13.4358 8.32081 13 7 13C5.6792 13 4.3953 13.4358 3.34743 14.2399C2.29957 15.0439 1.5463 16.1713 1.20445 17.4471" stroke="white" stroke-opacity="0.97" stroke-width="2" stroke-linecap="round"/>
            <path d="M16 7L16 13" stroke="white" stroke-opacity="0.97" stroke-width="2" stroke-linecap="round"/>
            <path d="M19 10L13 10" stroke="white" stroke-opacity="0.97" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Добавить</span>
        </button>
      </div>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="630px"
        >
        <div class="add-human">
          <div class="add-human_header">
            <h2>{{filter ? 'Фильтр поиска' : 'Добавить человека'}}</h2>
            <button class="filter-btn" @click="close()">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="add-human_form form">
            <div class="form_item">
              <div class="form_item-flex">
                <div class="form_item-name">
                  <label for="name">Имя</label>
                  <input type="text" id="name" class="form_item-input" v-model="human.name">
                </div>
                <div class="form_item-gender">
                  <label for="gender">Пол</label>
                  <v-select
                    hide-details
                    outlined
                    :items="gender"
                    v-model="human.gender"
                    required
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="form_item">
              <label for="age">Возраст от</label>
              <div class="form_item-flex">
                <div class="form_item-age-input">
                    <input type="number" class="form_item-input" v-model="human.ageFrom">
                </div>
                <div class="form_item-age-slider">
                  <v-slider
                    hide-details
                    v-model="human.ageFrom"
                    max="100"
                    min="0"
                  ></v-slider>
                </div>
                <div class="form_item-age-control">
                  <button class="minus" @click="--human.ageFrom">-</button>
                  <button class="pluse" @click="++human.ageFrom">+</button>
                </div>
                <div class="form_item-age-unit">
                  <v-select
                    hide-details
                    outlined
                    :items="unit"
                    v-model="human.years"
                    @change="changeAge()"
                    required
                  ></v-select>
                </div>
              </div>

            </div>
            <div class="form_item">
              <label for="age">Возраст до</label>
              <div class="form_item-flex">
                <div class="form_item-age-input">
                  <input type="number" class="form_item-input" v-model="human.ageTo">
                </div>
                <div class="form_item-age-slider">
                  <v-slider
                    v-model="human.ageTo"
                    max="100"
                    min="0"
                  ></v-slider>
                </div>
                <div class="form_item-age-control">
                  <button class="minus" @click="--human.ageTo">-</button>
                  <button class="pluse" @click="++human.ageTo">+</button>
                </div>
                <div class="form_item-age-unit">
                  <v-select
                    hide-details
                    outlined
                    :items="unit2"
                    v-model="human.days"
                    required
                  ></v-select>
                </div>
              </div>

            </div>
            <div class="form_item">
              <button class="form_item-submit" @click.prevent="save(filter)">{{filter ? 'Показать' : 'Добавить'}}</button>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
    <HumanList></HumanList>
  </div>
</template>

<script>
import "./index.scss";
import { mapActions, mapMutations, mapGetters } from "vuex";
import HumanList from '@/components/HumanList/HumanList'
export default {
  name: "Knowledge",
  components: {
    HumanList
  },
  data() {
    return {
      dialog: false,
      filter: false,
      gender: [
        {
          text: 'Мужчина',
          value: 1,
        },
        {
          text: 'Женщина',
          value: 2,
        }
      ],
      unit: [{text:'Лет', value: 0},{text:'Мес', value: 1},{text:'Дней', value: 2}],
      unit2: [{text:'Лет', value: 0},{text:'Мес', value: 1},{text:'Дней', value: 2}],
      defaultHuman: {
        id: null,
        name: '',
        itemType: 0,
        isGood: true,
        description: '',
        gender: null,
        ageFrom: 0,
        months: 0,
        days: 0,
        years: 0,
        ageTo: 0
      },
      human: {
        id: null,
        name: '',
        itemType: 0,
        isGood: true,
        description: '',
        gender: null,
        ageFrom: 0,
        months: 0,
        days: 0,
        years: 0,
        ageTo: 0
      },
    };
  },
  methods: {
    ...mapActions({
      addItem: "tree/addItem",
      searchItems: "tree/searchItems",
      searchHuman: "tree/searchHuman",
    }),
    ...mapMutations({
      setSystem: "tree/setSystem",
    }),
    open(filter) {
      this.dialog = true
      this.filter = filter
      this.human = this.defaultHuman
    },
    close() {
      this.dialog = false
      this.human = this.defaultHuman
    },
    save(filter) {
      if (filter) {
        this.searchHuman(this.human)
      } else {
        this.addItem(this.human).then(() => {
          this.searchHuman({})
        })
      }
      this.human = this.defaultHuman
      this.dialog = false
    },
    changeAge() {
      if (this.human.years === 0) {
        this.unit2 = [{text:'Лет', value: 0}]
      } else if (this.human.years === 1) {
        this.unit2 = [{text:'Лет', value: 0},{text:'Мес', value: 1}]
      } else {
        this.unit2 = [{text:'Лет', value: 0},{text:'Мес', value: 1},{text:'Дней', value: 2}]
      }
    }
  },
  computed: {
    ...mapGetters({
      getSystems: "tree/getSystems",
    }),
  },
  created() {
    this.searchItems({itemtype: 1})
    this.searchHuman({})
  },
};
</script>
